import React from "react";
import { IonCard, IonItem, IonLabel, IonIcon } from "@ionic/react";
import {
  navigateOutline,
  phonePortraitOutline,
  callOutline,
} from "ionicons/icons";
import {
  getAddress,
  getLocalPhoneNumber,
} from "../../../components/util/helpers";

var flatten = require("flat");

const Communications = (props) => {
  const { activePatient } = props;

  const address = getAddress(flatten(activePatient, { safe: true }));
  const mobile =
    activePatient.contact_info &&
    activePatient.contact_info.mobile_number &&
    getLocalPhoneNumber(activePatient.contact_info.mobile_number);

  const phone =
    activePatient.contact_info &&
    activePatient.contact_info.phone_number &&
    getLocalPhoneNumber(activePatient.contact_info.phone_number);

  const { geo } = activePatient;
  let toLat = geo && geo.latitude;
  let toLong = geo && geo.longtitude;
  let destination = toLat && toLong && toLat + "," + toLong;

  return (
    <IonCard>
      {address && (
        <IonItem
          button
          onClick={() => {
            if (destination) {
              window.open(
                "https://waze.com/ul?ll=" +
                  destination +
                  "&navigate=yes&zoom=10"
              );
            } else if (address) {
              window.open(
                "https://waze.com/ul?q=" + address.replace(/\s/g, "%20")
              );
            }
          }}
        >
          <IonIcon icon={navigateOutline} slot="start" />
          <IonLabel>{address}</IonLabel>
        </IonItem>
      )}
      {mobile && (
        <IonItem button onClick={() => {}} href={`tel:${mobile}`}>
          <IonIcon icon={phonePortraitOutline} slot="start" />
          <IonLabel>{mobile}</IonLabel>
        </IonItem>
      )}
      {phone && (
        <IonItem button onClick={() => {}} href={`tel:${phone}`} lines="none">
          <IonIcon icon={callOutline} slot="start" />
          <IonLabel>{phone}</IonLabel>
        </IonItem>
      )}
    </IonCard>
  );
};

export default Communications;
